import type { DevelopmentMandateSelections } from '@/config/developmentMandate';
import { DEVELOPMENT_MANDATE_SECTIONS } from '@/config/developmentMandate';

export function summarizeMandateTags(mandate: DevelopmentMandateSelections | null | undefined): string {
  if (!mandate) return '—';
  const tags: string[] = [];
  for (const section of DEVELOPMENT_MANDATE_SECTIONS) {
    const vals = mandate[section.key];
    if (!vals?.length) continue;
    const first = section.options.find((o) => o.value === vals[0]);
    if (first) tags.push(first.label);
    if (tags.length >= 3) break;
  }
  return tags.length ? tags.join(' · ') : 'Inherits account defaults';
}
